module.exports = __webpack_public_path__ + "static/img/bannerbg.ee6ef3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepageComponent/images/bannerbg.jpg
// module id = E/GL
// module chunks = 6